// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3vgFl","image":"Header_image__XaVsq","name":"Header_name__JcVHx","info":"Header_info__1dPB0","infoRow":"Header_infoRow__28Tx5"};